
const MOVED_SECTION_CLASS = "moved-message-section";

export default function checkAjaxResponse(context) {
  if (!isAjaxResponse(context)) {
    return;
  }

  const isSingleElement = isSingleElementResponse(context);
  const labellingInfo = getLabellingEl(context)

  if (!isSingleElement) {
    removeMovedMessages(labellingInfo);
  }

  const firstFocus = checkMessagesLocation(context, isSingleElement, labellingInfo) ?? getFirstFocus(context);
  if (firstFocus) {
    requestAnimationFrame(() => firstFocus.focus());
  }
}

function removeMovedMessages(labellingInfo) {
    const labellingEl = labellingInfo.labellingEl;
    if (labellingEl && labellingEl.dataset.movedErrorsId) {
        const movedErrorsEl = document.getElementById(labellingEl.dataset.movedErrorsId);
        movedErrorsEl.remove();
    }
}

/** 
 * Drupal has a few oddnesses with messages returned via ajax:
 * - When returning an ajax response for a single element (e.g. a file field), Drupal 
 * returns a redundant error summary section which is positioned mid-form right
 * above the actual helpful error message. Stripping it out is probably 
 * more helpful as it puts the user's attention on the single actual detailed message and 
 * erroneous field.
 * - Otherwise, the heading level of the messages section is hardcoded to h2,
 * which can conceal the actual form elements
 */
function checkMessagesLocation(context, isSingleElement, labellingInfo) {
     const messagesSection = getMessagesSection(context);
     if (messagesSection) {
        return getFocusableMessagesSection(messagesSection, isSingleElement, labellingInfo);
     } else {
        return null;
     }
}

function getMessagesSection(context) {
    const messagesSelector = 'section.status-messages';
    const messagesSection = context.matches(messagesSelector) ? context : context.querySelector(messagesSelector);
    return messagesSection;
}

function getFocusableMessagesSection(messagesSection, isSingleElement, labellingInfo) {
    if (isSingleElement) {
      messagesSection.remove();
      return null;
    } else {
      return formatMessagesSection(messagesSection, labellingInfo);
    }
}

function formatMessagesSection(messagesSection, labellingInfo) {
    if (labellingInfo.labellingEl) {
      setMessagesSectionHierarchy(messagesSection, labellingInfo);
      return messagesSection;
    } else {
      return null;
    }
}



function setMessagesSectionHierarchy(messagesSection, labellingInfo) {
   
    const {labelledParent, labellingEl} = labellingInfo;

    const errorsHeading = messagesSection.querySelector('h2');
    if (errorsHeading) {
        const newHeading = document.createElement(labellingEl.tagName);
        newHeading.innerHTML = errorsHeading.innerHTML;
        const attrs = errorsHeading.attributes;
        for (const attr of attrs) {
            newHeading.setAttribute(attr.name, attr.value);
        }
        errorsHeading.insertAdjacentElement('beforebegin', newHeading);
        errorsHeading.remove();
    }

    const wrapperEl = getBlankMessagesWrapper(labellingEl);
    messagesSection.remove();
    messagesSection.classList.add(MOVED_SECTION_CLASS);
    wrapperEl.insertAdjacentElement('afterbegin', messagesSection);
    labellingEl.dataset.movedErrorsId = wrapperEl.id;
}

function getBlankMessagesWrapper(labellingEl) {
    const messagesWrapperId = `${labellingEl.id}-msg-wrapper`;
    const existingElement = document.getElementById(messagesWrapperId);
    if (existingElement) {
        existingElement.innerHTML = '';
        return existingElement;
    } else {
        const newElement = document.createElement('div');
        newElement.id = messagesWrapperId;
        labellingEl.insertAdjacentElement('beforebegin', newElement);
        return newElement;
    }
}

function getLabellingEl(context) {
    const labelledFormSelector =
      "form[aria-labelledby], *[role=form][aria-labelledby]";
    const labelledParent = context.matches(labelledFormSelector)
      ? context
      : (context.closest(labelledFormSelector) ??
        context.querySelector(labelledFormSelector));
    if (labelledParent) {
        const firstId = (labelledParent.getAttribute("aria-labelledby") ?? '').split(" ")[0];
        return {labelledParent: labelledParent, labellingEl: document.getElementById(firstId)};
    } else {
        return {labelledParent: null, labellingEl: null};
    }
}

//get first element marked as auto-focusable. This can be an errors section.
function getFirstFocus(context) {
    return context.querySelector(".js-wf-ajax-autofocus");
}

function isAjaxResponse(context) {
    return context && context.querySelector && context.tagName && !('form' == context.tagName.toLowerCase() && !context.querySelector('.webform-confirmation'));
}

function isSingleElementResponse(context) {
    return context && (context.id ?? "").indexOf("ajax-wrapper") > -1 && "form" !== context.tagName.toLowerCase() && !context.querySelector("form")
}

